import { AbsurdIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type { Vendor } from '../vendorTypes';
import {
  isArubaNewCentralVendor,
  isAwsVendor,
  isAzureVendor,
  isCheckPointVendor,
  isCiscoApicVendor,
  isCiscoFmcVendor,
  isF5osAVendor,
  isF5osCVendor,
  isForcePointVendor,
  isGcpVendor,
  isJuniperMistVendor,
  isMerakiVendor,
  isNsxTVendor,
  isPrismaVendor,
  isRuckusVendor,
  isSilverPeakVendor,
  isVeloCloudVendor,
  isVersaVendor,
  isViptelaVendor,
} from './guardTypes';

export const deleteVendorApiTemporaryAttributes = (row: Vendor): Vendor => {
  if (isAwsVendor(row)) {
    const { baseUrl, apiVersion, details, ...rest } = row;
    return rest;
  }

  if (
    isVersaVendor(row) ||
    isSilverPeakVendor(row) ||
    isCiscoFmcVendor(row) ||
    isNsxTVendor(row) ||
    isCiscoApicVendor(row)
  ) {
    const { apiVersion, details, ...rest } = row;
    return rest;
  }

  if (
    isGcpVendor(row) ||
    isForcePointVendor(row) ||
    isPrismaVendor(row) ||
    isAzureVendor(row) ||
    isCheckPointVendor(row) ||
    isF5osAVendor(row) ||
    isF5osCVendor(row) ||
    isJuniperMistVendor(row) ||
    isRuckusVendor(row) ||
    isSilverPeakVendor(row) ||
    isViptelaVendor(row) ||
    isMerakiVendor(row) ||
    isVeloCloudVendor(row) ||
    isArubaNewCentralVendor(row)
  ) {
    const { details, ...rest } = row;
    return rest;
  }

  throw new AbsurdIpfError(row, 'unknown vendor type');
};
